export enum LESSON_TYPE {
  LIVE = 'live',
  VOD = 'vod',
}

export enum LiveStatus {
  NEXT = 'Agendada',
  LIVE = 'Transmissão',
  RERUN = 'Reprise',
  RECORDED = 'Gravada',
}

export enum TRANSMISSION_TYPE {
  LIVE_EDITED = 'live-edited',
  LIVE = 'live',
  RECORDED_LESSON = 'recorded-lesson',
  LIVE_RERUN = 'live-rerun',
}
